export enum ChartType {
    Media = 1,
    Status = 2,
    Type = 3,
}
